import styled from "styled-components/macro";

export const SplashWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background: #6ec1e4;
  color: white;
  margin-bottom: 20px;
  //padding: 24px;
  border-radius: 12px;
  box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  @media screen and (max-width: 590px) {
    margin-left: -14px;
    margin-right: -14px;
    margin-top: -34px;
  }
`;
